<template>
  <b-modal id="deviceOrderModal" title="Change Device Order" :visible="visible" @hide="hideModal" @ok="onOk" @cancel="onCancel">
    <div>
        Click and drag to swap devices.<br /><br />
        <b class="active-label">ACTIVE</b> devices are displayed in <b class="active-label">purple</b>.<br />
        <b class="inactive-label">INACTIVE</b> devices are displayed in <b class="inactive-label">red</b>.<br /><br />
    </div>
    <draggable v-model="localDevices" handle=".handle">
      <div v-for="(device, index) in localDevices" :key="device.macaddress + device.priority" class="d-flex align-items-center mb-2">
        <div :class="'handle mr-2 ' + (index < max ? 'active-label' : 'inactive-label')">{{index + 1}} &nbsp;≡</div>
        <div :class="'handle ' + (index < max ? 'active-label' : 'inactive-label')"><b>{{ device.devicetype.description }}<span v-if="device.description"> - {{ device.description }}</span></b></div>
      </div>
    </draggable>
    <template #modal-footer>
      <b-button @click="onCancel">Cancel</b-button>
      <b-button variant="primary" @click="onOk">Save</b-button>
    </template>
  </b-modal>
</template>

<script>
    import draggable from 'vuedraggable';

    export default {
        name: 'DeviceOrderModal',
        components: {
            draggable
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            devices: {
                type: Array,
                required: true
            },
            max: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                localDevices: []
            }
        },
        watch: {
            devices: {
                immediate: true,
                handler(newVal) {
                    this.$log.onDebug('new val is ' + JSON.stringify(newVal))
                    this.localDevices = [...newVal];
                },
            },
        },
        methods: {
            hideModal() {
                this.$emit('update:visible', false);
            },
            onOk() {
                this.$log.onDebug("Save new devices order");
                this.$emit('update:devices', this.localDevices);
                this.$bvModal.hide('deviceOrderModal');
            },
            onCancel() {
                this.localDevices = this.devices;
                this.$bvModal.hide('deviceOrderModal');
            },
        }
    };
</script>

<style>

.handle {
  cursor: move;
}

.active-label {
  color: purple;
}

.inactive-label {
  color: red;
}

</style>